import type { MisconceptionDefinition } from '../types'

export const onregelmatigSterkMisconceptions: MisconceptionDefinition[] = [
  // === Onregelmatige verleden tijd (SWW-VT-ONREGELMATIG) — added mei 2026
  // Unblocks Fase C format-migratie van SWW-VT-ONREGELMATIG Q001/Q003.
  // NL-genaamde tags acceptabel voor Nederlandse werkwoordsanalyse.
  // Let op: sww.onregelmatig-als-regelmatig is semantisch een synoniem van
  // de bestaande sww.irregular-verb-regularized. Bewust beide aangehouden
  // omdat seeds de NL-naam gebruiken; consolidatie kan later (audit K6).
  {
    id: 'sww.onregelmatig-als-regelmatig',
    label: 'Onregelmatig werkwoord regelmatig vervoegd',
    module: 'SpellingWW',
    description:
      'Leerling past de zwakke (kofschip-)regel toe op een onregelmatig werkwoord (bv. "denkde" i.p.v. "dacht", "mogden" i.p.v. "mochten").',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VD-STERK'],
  },
  {
    id: 'sww.tt-vt-verwarring',
    label: 'Tegenwoordige tijd verward met verleden tijd',
    module: 'SpellingWW',
    description:
      'Leerling kiest de tegenwoordige-tijdvorm waar de verleden tijd vereist is (bv. "is" i.p.v. "was").',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VT-STERK', 'SWW-VT-DUBBEL'],
  },
  {
    id: 'sww.zijn-worden-verwarring',
    label: 'Verleden tijd van "zijn" en "worden" verward',
    module: 'SpellingWW',
    description:
      'Leerling kiest "werd" (verleden tijd van worden) waar "was" (verleden tijd van zijn) vereist is, of andersom.',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VT-ZIJN-HEBBEN'],
  },
  {
    id: 'sww.kofschip-op-sterk-ww',
    label: 'Kofschip-regel toegepast op sterk werkwoord',
    module: 'SpellingWW',
    description:
      'Leerling past de kofschip-regel toe op een sterk/onregelmatig werkwoord, terwijl de juiste vorm een klankverandering vereist (bv. "denkde" i.p.v. "dacht").',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VT-STERK'],
  },
  {
    id: 'sww.dubbele-uitgang',
    label: 'Dubbele uitgang toegevoegd aan verleden tijd',
    module: 'SpellingWW',
    description:
      'Leerling voegt een overbodige -te of -de toe aan een vorm die al compleet is (bv. "mochtte" i.p.v. "mocht").',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VT-DUBBEL'],
  },
  {
    id: 'sww.regelmatig-als-onregelmatig',
    label: 'Regelmatig werkwoord onterecht als onregelmatig aangemerkt',
    module: 'SpellingWW',
    description:
      'Leerling denkt dat een regelmatig (zwak) werkwoord onregelmatig is, en zoekt naar een klankverandering die er niet hoort (bv. "werken" als onregelmatig zien).',
    typicalFamilies: ['SWW-VT-ONREGELMATIG'],
  },
  {
    id: 'sww.sterk-zwak-verwarring',
    label: 'Sterk en zwak werkwoord verward',
    module: 'SpellingWW',
    description:
      'Leerling kan sterke werkwoorden (klankverandering) niet onderscheiden van zwakke werkwoorden (kofschip-regel) bij categorisatie.',
    typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VT-STERK', 'SWW-VT-ZWAK-KOF'],
  },
  // === Sterk werkwoord voltooid deelwoord (SWW-VD-STERK) — added mei 2026
  // Unblocks pedagogy validator (PEDAGOGY_MISCONCEPTION_UNKNOWN) voor SWW-VD-STERK-001
  // en variants. Sterk VD eindigt altijd op -en; geen kofschip-toepassing toegestaan.
  {
    id: 'sww.vd-sterk-als-zwak',
    label: 'Sterk werkwoord behandeld als zwak (kofschip op VD)',
    module: 'SpellingWW',
    description:
      'Leerling past de kofschip-regel toe op een sterk werkwoord in het voltooid deelwoord (bv. "geloopt" i.p.v. "gelopen"), terwijl sterke VD\'s altijd op -en eindigen.',
    typicalFamilies: ['SWW-VD-STERK'],
  },
  {
    id: 'sww.vd-dubbele-klinker',
    label: 'Dubbele klinker in voltooid deelwoord',
    module: 'SpellingWW',
    description:
      'Leerling schrijft een dubbele klinker in het VD waar de open lettergreep enkele klinker vereist (bv. "geloopen" i.p.v. "gelopen").',
    typicalFamilies: ['SWW-VD-STERK', 'SWW-VD-KOF'],
  },
  {
    id: 'sww.vd-verkeerde-uitgang',
    label: 'VD op -d/-t i.p.v. -en bij sterk werkwoord',
    module: 'SpellingWW',
    description:
      'Leerling geeft het voltooid deelwoord van een sterk werkwoord de kofschip-uitgang -d/-t (bv. "gelopd") in plaats van -en.',
    typicalFamilies: ['SWW-VD-STERK'],
  },
  // === SWW seed-driven additions (mei 2026) — Q-IDs in seeds gebruikten deze tags al ===
  {
    id: 'sww.vd-klinker-niet-veranderd',
    label: 'Klinker niet veranderd bij sterk VD',
    module: 'SpellingWW',
    description:
      'Leerling behoudt de oorspronkelijke stamklinker in het voltooid deelwoord i.p.v. de vereiste klankverandering toe te passen (bv. "gedrinkt" i.p.v. "gedronken").',
    typicalFamilies: ['SWW-VD-STERK'],
  },
]
